import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3b1d4120-6f2e-4f01-8ec6-ab509dc939c8", content: "Velocity amplitude", options: {} },
  { id: "2d718163-3d92-42b0-bfa4-e0e5d58a4652", content: "Acoustic pressure", options: {} },
  { id: "cd9c8cff-61c5-4a48-8796-a20bf7b2cf48", content: "Acoustic power", options: {} },
];

const groups = [
  { id: "605f146d-461c-41ec-a94d-5baae7a90a2c", content: "0.125 m/s", options: {} },
  { id: "84a7c339-032a-4e67-9db4-1bc4287e4484", content: "1.25 m/s", options: {} },
  { id: "b7ed5c55-2978-4974-b42e-f8876424a9f4", content: "0.2 m/s", options: {} },
  { id: "a639ccb1-ad80-4ba8-a2d5-fd9b08b981dd", content: "0.125 m/s", options: {} },
  { id: "8905ce45-f438-4391-8db8-9fbdd5f90a8c", content: "500 Pa", options: {} },
  { id: "8e622687-ee65-4943-8a04-26ef16d62755", content: "50 Pa", options: {} },
  { id: "682ad15e-6a46-4ebf-8556-9474c01e2b8a", content: "79 Pa", options: {} },
  { id: "19c0d66f-0e5e-431c-b274-eeb545cbbce2", content: "0.004 W", options: {} },
  { id: "1f355de6-8619-422b-9af4-b062ec086420", content: "1 579 W", options: {} },
  { id: "209cf7df-fd0e-45d9-81aa-800471d60e03", content: "0.16 W", options: {} },
];

export const task: Task = {
  id: "6c0ee760-4ce4-45f5-b59b-84bdc14b34ab",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "84a7c339-032a-4e67-9db4-1bc4287e4484", itemsId: ["3b1d4120-6f2e-4f01-8ec6-ab509dc939c8"] },
    { groupId: "8905ce45-f438-4391-8db8-9fbdd5f90a8c", itemsId: ["2d718163-3d92-42b0-bfa4-e0e5d58a4652"] },
    { groupId: "209cf7df-fd0e-45d9-81aa-800471d60e03", itemsId: ["cd9c8cff-61c5-4a48-8796-a20bf7b2cf48"] },
  ],
};
